window.onload = function () {
  var $swiperSnap = $("#snap-swiper");
  var slidesInView = 3;
  var breakpoints = {
    767: {
      slidesPerView: 2.2,
      spaceBetween: 10,
    },
    900: {
      slidesPerView:
        slidesInView === 4 || slidesInView === 3 ? 2 : slidesInView,
    },
    1439: {
      slidesPerView:
        slidesInView === 4 || slidesInView === 3 ? 3 : slidesInView,
    },
    3000: {
      slidesPerView: slidesInView,
      spaceBetween: 20,
    },
  };
  new Swiper($swiperSnap, {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    freeMode: true,
    freeModeFluid: true,
    scrollContainer: true,
    grabCursor: true,
    createPagination: false,
    slidesPerView: slidesInView,
    spaceBetween: 20,
    mousewheel: {
      invert: true,
      forceToAxis: true,
    },
    scrollbar: {
      el: $swiperSnap.find(".swiper-scrollbar")[0],
      draggable: true,
    },
    navigation: {
      nextEl: $swiperSnap.find(".swiper-button-next")[0],
      prevEl: $swiperSnap.find(".swiper-button-prev")[0],
    },
    breakpoints: breakpoints,
    on: {
      init: function init() {
        lazySizes.autoSizer.checkElems();
      },
    },
  });
};
